jQuery(function($) {
  
  $(".ProductMeta .ProductMeta__PriceList").bind("DOMSubtreeModified", function() {
  	let priceHtml = $(this).html();
    if(priceHtml) {
      priceHtml = '<div class="ProductMeta__PriceList Heading">' + priceHtml + '</div>';
      $(".ProductMetaPrice .ProductMeta__PriceList").remove();
      $(".ProductMetaPrice").html(priceHtml);
    }
  });
  
  
  $(".ProductSection--popupLink").on("click", function() {
    $(this).parent().addClass("popupActive");
    $("body").addClass("show-Productpopup");
  });
  
  $(".ProductSection-popupWrapper").on("click", function() {
    $(this).parent().removeClass("popupActive");
    $("body").removeClass("show-Productpopup");
  });
  
});